import { createReducer, Action, on } from '@ngrx/store';
import { differenceBy } from 'lodash-es';

import { ConversationActions } from './conversation.actions';
import { ConversationState } from './conversation.state';
import { measureReducer } from '../../features/shared/utils/runtime-reducer-stats';

export const initialState: ConversationState = {
  anchoredConversation: [],
};

const featureReducer = measureReducer(
  createReducer(
    initialState,
    on(
      ConversationActions.DownloadConversationCountsSuccess,
      (state, action): ConversationState => ({
        ...state,
        anchoredConversation: action.anchoredConversation,
      })
    ),
    on(
      ConversationActions.ClearConversationCounts,
      (state, action): ConversationState => ({ ...state, anchoredConversation: [] })
    ),
    on(
      ConversationActions.AppendConversationCounts,
      (state, action): ConversationState => ({
        ...state,
        anchoredConversation: [
          ...state.anchoredConversation,
          ...differenceBy(
            action.anchoredConversation || [],
            state.anchoredConversation,
            (a) => a._id
          ),
        ],
      })
    ),
    on(
      ConversationActions.ConversationDeleted,
      (state, action): ConversationState => ({
        ...state,
        anchoredConversation: state.anchoredConversation.filter((c) => c._id !== action._id),
      })
    ),
    on(
      ConversationActions.AddPendingConversation,
      (state, action): ConversationState => ({
        ...state,
        pendingConversation: action.pendingConversation,
      })
    ),

    on(
      ConversationActions.ClearPendingConversation,
      (state, action): ConversationState => ({
        ...state,
        pendingConversation: null,
      })
    )
  )
);

export function reducer(state: ConversationState | undefined, action: Action) {
  return featureReducer(state, action);
}
